import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormBanco07  extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            fechaDesde: null,
            fechaHasta: null,

            tipo_sel: null,
            tipo_opt: [],

            banco_sel: null,
            banco_opt: []
        };
        
        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impMovimientoTipo = this.impMovimientoTipo.bind(this);
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        
        this.setState({[name]: value});
    }    

    componentDidMount(){
        Promise.all([
            cargarCatalogos_Otros('TIPODOC-BAN'),
            cargarCatalogos_Otros('BAN-CTASDEP'),
            this.props.generar_LogAuditoriaIngresoForm('0707')
         ])
        .then(([ tipo, bancos ]) => {    
            
            let fechaProceso = getFechaProcesoPorModulo('07');            
            this.setState({ fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                            fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
                            tipo_opt: tipo,
                            banco_opt: bancos});
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0707');
    }
   

    limpiar(){        
        let fechaProceso = getFechaProcesoPorModulo('07');
        this.setState({ fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                        fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
                        tipo_sel: null,
                        banco_sel: null
                    });       
    }

    impMovimientoTipo(){
        var continuar = true;
        var error = "";
        var errorAnio = false;            

        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        if(continuar === true){
            var parametros = ""
            parametros = '&rpt=33&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)

            if(this.state.tipo_sel!==null){
                parametros = parametros+'&param3='+this.state.tipo_sel
            }


            if(this.state.banco_sel!==null){
                parametros = parametros+'&param4='+this.state.banco_sel
            }

            visualizarReporteEnPdf(parametros);

        }else{
            alert(error)
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Movimientos Banco por Tipo</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba='15' margen_abajo='8'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_abajo='4'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>                        
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Tipo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                            <ReactSelect options={ this.state.tipo_opt } value={this.state.tipo_sel} func_onChange={(value)=>{this.setState({tipo_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Cuenta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                            <ReactSelect options={ this.state.banco_opt } value={this.state.banco_sel} func_onChange={(value)=>{this.setState({banco_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>                        
                    </Row>                    
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm'  onClick={this.impMovimientoTipo}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormBanco07);